import { Grab16 } from '@yunex/yds-icons';
import { Box, SvgIcon } from '@yunex/yds-react';
import React, { useEffect, useRef } from 'react';
// Styles.
var styles = {
    root: {
        cursor: 'grab',
        display: 'flex',
        placeItems: 'center',
        color: 'text.hint',
    },
};
export var RowDragCellRenderer = function (props) {
    var myRef = useRef(null);
    useEffect(function () {
        props.registerRowDragger(myRef.current);
        return function () { };
    }, []);
    return (React.createElement(Box, { ref: myRef, sx: styles.root },
        React.createElement(SvgIcon, { component: Grab16 })));
};
//# sourceMappingURL=RowDragCellRenderer.js.map